import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePicker from '@alifd/next/lib/date-picker';
import moment from 'moment';

/**
 * Compatible `locale` to moment's locale format
 * moment's doesn't recognize regionless chinese locale like `zh`
 * @param {String} locale
 */
var fixLocale = function fixLocale(locale) {
  return locale === 'zh' ? 'zh-cn' : locale;
};
/**
 * Give `format` prop a default value, based on current locale.
 */


var withIntlFormat = function withIntlFormat(WrappedComponent) {
  var _class, _temp;

  return (// eslint-disable-next-line react/prefer-stateless-function
    _temp = _class = /*#__PURE__*/function (_Component) {
      _inherits(H, _Component);

      var _super = _createSuper(H);

      function H() {
        _classCallCheck(this, H);

        return _super.apply(this, arguments);
      }

      _createClass(H, [{
        key: "render",
        // Access context temporary
        // TODO: Will be refactor with PR
        value: function render() {
          var _this$props = this.props,
              format = _this$props.format,
              restProps = _objectWithoutProperties(_this$props, ["format"]); // Access context temporary
          // TODO: Will be refactor with PR


          var _this$context$nextLoc = this.context.nextLocale;
          _this$context$nextLoc = _this$context$nextLoc === void 0 ? {} : _this$context$nextLoc;
          var momentLocale = _this$context$nextLoc.momentLocale; // dummy momentInstance to normalize locale string

          var momentInstance = moment();
          var currentLocale = momentInstance.locale(fixLocale(momentLocale) || 'en'); // if value is a moment instance already, get locale from it

          var value = restProps.value,
              defaultValue = restProps.defaultValue;
          var exactValue = value || defaultValue;

          if (moment.isMoment(exactValue)) {
            currentLocale = exactValue.locale();
          }

          var defaultFormat = moment.localeData(currentLocale).longDateFormat('ll');
          var exactFormat = typeof format !== 'undefined' ? format : defaultFormat;

          var props = _objectSpread(_objectSpread({}, restProps), {}, {
            format: exactFormat
          });

          return /*#__PURE__*/React.createElement(WrappedComponent, props);
        }
      }]);

      return H;
    }(Component), _defineProperty(_class, "displayName", "withIntlFormat(".concat(WrappedComponent.displayName, ")")), _defineProperty(_class, "propTypes", {
      format: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.object])
    }), _defineProperty(_class, "contextTypes", {
      nextLocale: PropTypes.objectOf(PropTypes.any)
    }), _temp
  );
};

var RangePicker = DatePicker.RangePicker,
    MonthPicker = DatePicker.MonthPicker,
    YearPicker = DatePicker.YearPicker,
    WeekPicker = DatePicker.WeekPicker;
var WrappedDatePicker = withIntlFormat(DatePicker);
WrappedDatePicker.RangePicker = withIntlFormat(RangePicker);
WrappedDatePicker.MonthPicker = withIntlFormat(MonthPicker);
WrappedDatePicker.YearPicker = withIntlFormat(YearPicker);
WrappedDatePicker.WeekPicker = withIntlFormat(WeekPicker);
export default WrappedDatePicker;